{
  "settings.title": "Innstillinger",
  "settings.workshop": "Verksted",
  "settings.save": "Lagre endringer",
  "settings.saving": "Lagrer …",
  "settings.saved": "Lagret",
  "settings.discard": "Angre endringer",
  "settings.unsaved": "Du har endringer som ikke er lagret.",
  "settings.leave_warning": "Du har ulagrede endringer. Vil du forlate siden likevel?",
  "settings.error": "Det gikk ikke å lagre. Prøv igjen.",
  "settings.retry": "Prøv igjen",
  "settings.load_error": "Vi fikk ikke hentet innstillingene.",
  "settings.cancel": "Avbryt",
  "settings.remove": "Fjern",
  "settings.add": "Legg til",
  "settings.nav.hours": "Åpningstider",
  "settings.nav.staff": "Ansatte og ressurser",
  "settings.nav.services": "Tjenester og priser",
  "settings.nav.rules": "Bestillingsregler",
  "settings.nav.reminders": "Påminnelser",
  "settings.nav.mobile": "Ambulerende virksomhet",
  "settings.nav.profile": "Profil",
  "settings.nav.calendar": "Kalendersynk",
  "settings.calendar.heading": "Kalendersynk",
  "settings.calendar.body": "Koble til Google Kalender, så vises ColorGlo-jobbene der de ansatte allerede ser. Bestillinger fungerer som vanlig selv om Google er nede.",
  "settings.calendar.unavailable": "Google Kalender er ikke slått på i dette miljøet. Ta kontakt med support.",
  "settings.calendar.connections": "Tilkoblede kontoer",
  "settings.calendar.connect": "Koble til Google Kalender",
  "settings.calendar.reconnect": "Koble til på nytt",
  "settings.calendar.disconnect": "Koble fra",
  "settings.calendar.sync_now": "Synk nå",
  "settings.calendar.syncing": "Synker …",
  "settings.calendar.queued": "Synkingen ligger i kø.",
  "settings.calendar.status.connected": "Tilkoblet",
  "settings.calendar.status.degraded": "Må kobles til på nytt",
  "settings.calendar.status.disconnected": "Ikke tilkoblet",
  "settings.calendar.last_synced": "Sist synket {when}",
  "settings.calendar.never_synced": "Aldri synket",
  "settings.calendar.pending.one": "{count} jobb venter på å bli sendt",
  "settings.calendar.pending.other": "{count} jobber venter på å bli sendt",
  "settings.calendar.disconnect_confirm": "Koble fra {account}? ColorGlos bestillinger fjernes fra kalenderen.",
  "settings.calendar.disconnect_keep": "Koble fra og behold hendelsene",
  "settings.calendar.disconnected": "Tilkoblingen er fjernet.",
  "settings.calendar.privacy.heading": "Hva som vises i kalenderen",
  "settings.calendar.privacy.body": "Gjelder alle tilkoblede kontoer på verkstedet. Telefonen til en tekniker viser kalenderen på låseskjermen, så velg ikke mer enn dere trenger.",
  "settings.calendar.privacy.full": "Fullstendige opplysninger",
  "settings.calendar.privacy.full_hint": "Tjeneste, kundens fornavn, telefon og adresse.",
  "settings.calendar.privacy.initials": "Bare initialer",
  "settings.calendar.privacy.initials_hint": "Tjeneste og kundens initialer. Ingen telefon.",
  "settings.calendar.privacy.busy": "Bare «Opptatt»",
  "settings.calendar.privacy.busy_hint": "Ingenting om jobben vises.",
  "settings.calendar.privacy.saved": "Lagret. Kommende bestillinger skrives om.",
  "settings.calendar.feeds.heading": "Abonnementslenker (ICS)",
  "settings.calendar.feeds.body": "Skrivebeskyttede lenker å abonnere på i Apple Kalender eller Outlook. Lenken vises én gang — kopier den nå.",
  "settings.calendar.feeds.create": "Lag lenke",
  "settings.calendar.feeds.rotate": "Bytt lenke",
  "settings.calendar.feeds.revoke": "Trekk tilbake",
  "settings.calendar.feeds.whole_franchise": "Hele verkstedet",
  "settings.calendar.feeds.copy": "Kopier",
  "settings.calendar.feeds.copied": "Lenken er kopiert.",
  "settings.calendar.feeds.once": "Dette er eneste gangen lenken vises. Lagrer du den ikke, må du lage en ny.",
  "settings.calendar.feeds.never_used": "Aldri hentet",
  "settings.calendar.feeds.last_used": "Hentet {when}",
  "settings.calendar.feeds.none": "Ingen lenker ennå.",
  "settings.hours.heading": "Åpningstider",
  "settings.hours.body": "Tidene her styrer når kunder kan bestille. Ansatte som følger verkstedets tider får dem med én gang.",
  "settings.hours.closed": "Stengt",
  "settings.hours.open": "Åpent",
  "settings.hours.from": "Fra",
  "settings.hours.to": "Til",
  "settings.hours.add_break": "Legg til pause",
  "settings.hours.break_hint": "To rader samme dag betyr at dere har stengt imellom.",
  "settings.hours.overlap": "Tidene samme dag overlapper hverandre.",
  "settings.hours.order": "Sluttidspunktet må være etter starttidspunktet.",
  "settings.hours.holidays": "Røde dager",
  "settings.hours.holidays_body": "Kryss av for dagene dere holder stengt. Kunder kan da ikke bestille den dagen.",
  "settings.hours.special": "Særskilte dager",
  "settings.hours.special_body": "Ekstra åpent eller tidlig stenging en enkelt dag.",
  "settings.hours.special_empty": "Ingen særskilte dager lagt inn.",
  "settings.hours.special_kind": "Hva gjelder?",
  "settings.hours.special_closed": "Stengt hele dagen",
  "settings.hours.special_extra": "Ekstra åpent",
  "settings.hours.special_date": "Dato",
  "settings.hours.special_reason": "Grunn",
  "settings.staff.heading": "Ansatte og ressurser",
  "settings.staff.body": "Alle som utfører jobber, og bilene og plassene som bestilles. Hver rad blir en egen kolonne i kalenderen.",
  "settings.staff.name": "Navn",
  "settings.staff.type": "Type",
  "settings.staff.type.staff": "Person",
  "settings.staff.type.van": "Bil",
  "settings.staff.type.bay": "Plass",
  "settings.staff.color": "Farge i kalenderen",
  "settings.staff.bookable": "Kan bestilles",
  "settings.staff.active": "Aktiv",
  "settings.staff.inherits": "Følger verkstedets åpningstider",
  "settings.staff.own_hours": "Egne arbeidstider",
  "settings.staff.skills": "Utfører disse tjenestene",
  "settings.staff.skills_empty": "Ingen tjeneste valgt — da kan ingen bestilling legges her.",
  "settings.staff.add": "Legg til person eller ressurs",
  "settings.staff.added": "Lagt til.",
  "settings.staff.remove": "Fjern",
  "settings.staff.remove_heading": "Fjerne {name}?",
  "settings.staff.remove_body.one": "{count} kommende bestilling er tildelt {name}.",
  "settings.staff.remove_body.other": "{count} kommende bestillinger er tildelt {name}.",
  "settings.staff.remove_none": "{name} har ingen kommende bestillinger.",
  "settings.staff.remove_assign_body": "Velg hvem som tar hver bestilling. Den som er opptatt på tidspunktet kan ikke velges.",
  "settings.staff.remove_assign_all": "Gi alle tider personen er ledig til",
  "settings.staff.remove_free_count": "ledig for {free} av {count}",
  "settings.staff.remove_pick": "Velg person",
  "settings.staff.remove_option_free": "Ledig",
  "settings.staff.remove_option_busy": "Opptatt",
  "settings.staff.remove_option_hours": "Utenfor arbeidstid",
  "settings.staff.remove_option_skill": "Utfører ikke tjenesten",
  "settings.staff.remove_progress": "{done} av {count} bestillinger har fått en ny person.",
  "settings.staff.remove_no_candidates": "Det finnes ingen andre som kan ta bestillingene. Legg til en person først og flytt deretter bestillingene.",
  "settings.staff.remove_conflict": "{name} ble booket i mellomtiden. Velg noen andre for denne bestillingen.",
  "settings.staff.remove_new_booking": "En ny bestilling har kommet inn i mellomtiden. Velg hvem som tar den også.",
  "settings.staff.remove_no_customer": "Kunde mangler",
  "settings.staff.remove_confirm": "Fjern og flytt bestillingene",
  "settings.staff.remove_confirm_empty": "Fjern",
  "settings.staff.deactivate": "Deaktiver i stedet",
  "settings.staff.deactivate_hint": "En deaktivert person forsvinner fra kalenderen, men beholder historikken sin.",
  "settings.staff.deactivated_notice": "{name} er deaktivert slik at bestillingshistorikken beholdes.",
  "settings.staff.reactivate": "Aktiver igjen",
  "settings.staff.invite": "Inviter med e-post",
  "settings.staff.invite_email": "E-postadresse",
  "settings.staff.invite_send": "Lag invitasjonen",
  "settings.staff.invite_pending": "Venter på svar",
  "settings.staff.invite_link": "Send denne lenken til {email}:",
  "settings.staff.invite_copy": "Kopier lenken",
  "settings.staff.invite_copied": "Lenken er kopiert.",
  "settings.staff.invite_revoke": "Trekk tilbake",
  "settings.staff.invite_expires": "Lenken gjelder til {date}.",
  "settings.services.heading": "Tjenester og priser",
  "settings.services.body": "Nettverkets tjenester. Slå på det dere utfører, og endre tid eller pris der dere skiller dere ut.",
  "settings.services.enabled": "Tilbys her",
  "settings.services.inherited": "Nettverkets verdi: {value}",
  "settings.services.duration": "Tid",
  "settings.services.price": "Pris",
  "settings.services.buffer_before": "Forberedelse før",
  "settings.services.buffer_after": "Etterarbeid etter",
  "settings.services.max_per_day": "Maks per dag",
  "settings.services.max_per_day_hint": "0 betyr ingen grense.",
  "settings.services.assessment": "Krever befaring",
  "settings.services.assessment_hint": "Kunden bestiller en kort befaring og får et tilbud etterpå — ingen pris vises.",
  "settings.services.reset": "Bruk nettverkets verdi",
  "settings.services.minutes": "minutter",
  "settings.services.disable_heading": "Slutte å tilby {name}?",
  "settings.services.disable_body.one": "Tjenesten forsvinner fra bestilling på nettet med én gang. {count} kommende bestilling påvirkes ikke.",
  "settings.services.disable_body.other": "Tjenesten forsvinner fra bestilling på nettet med én gang. {count} kommende bestillinger påvirkes ikke.",
  "settings.services.disable_confirm": "Slutt å tilby",
  "settings.rules.heading": "Bestillingsregler",
  "settings.rules.body": "Rammene for hva en kunde kan bestille selv på nettet.",
  "settings.rules.min_notice": "Hvor sent kan kunder bestille?",
  "settings.rules.min_notice_hint": "Tider som ligger nærmere enn dette går ikke å bestille på nettet. Dere kan alltid legge dem inn selv.",
  "settings.rules.max_horizon": "Hvor langt fram kan kunder bestille?",
  "settings.rules.max_horizon_hint": "Kalenderen på nettet viser ikke lenger fram enn dette.",
  "settings.rules.granularity": "Hvor tett ligger tidene?",
  "settings.rules.granularity_hint": "Kunden velger på jevne intervaller — 30 minutter er det vanligste.",
  "settings.rules.auto_confirm": "Bekreft bestillinger automatisk",
  "settings.rules.auto_confirm_hint": "Kunden får en bekreftelse med én gang. Er det slått av, får kunden vite at dere kommer tilbake.",
  "settings.rules.same_day": "Tillat bestilling samme dag",
  "settings.rules.cancellation": "Hvor sent kan kunden avbestille selv?",
  "settings.rules.cancellation_hint": "Senere enn dette må kunden ringe dere i stedet. Å avbestille skal aldri være vanskeligere enn å bestille.",
  "settings.rules.max_per_day": "Maks bestillinger per dag",
  "settings.rules.max_per_day_hint": "0 betyr ingen grense.",
  "settings.rules.hours": "timer",
  "settings.rules.days": "dager",
  "settings.rules.minutes": "minutter",
  "settings.reminders.heading": "Påminnelser",
  "settings.reminders.body": "Én e-post per rad. Les raden høyt — står det riktig, gjør den riktig.",
  "settings.reminders.sentence": "Send {channel} {offset} {event}",
  "settings.reminders.channel.email": "e-post",
  "settings.reminders.offset.before": "{value} før",
  "settings.reminders.offset.after": "{value} etter",
  "settings.reminders.offset.immediately": "med én gang",
  "settings.reminders.event.booked": "bestilt tid",
  "settings.reminders.event.confirmed": "bekreftet bestilling",
  "settings.reminders.event.rescheduled": "flyttet bestilling",
  "settings.reminders.event.cancelled": "avbestilling",
  "settings.reminders.event.no_show": "kunde som ikke møtte",
  "settings.reminders.event.completed": "fullført jobb",
  "settings.reminders.template": "E-post",
  "settings.reminders.template_name.booking_confirmed": "Bestillingsbekreftelse",
  "settings.reminders.template_name.reminder": "Påminnelse",
  "settings.reminders.template_name.rescheduled": "Flyttet bestilling",
  "settings.reminders.template_name.cancelled": "Avbestilling",
  "settings.reminders.template_name.assessment_booked": "Bestilt befaring",
  "settings.reminders.template_name.job_completed": "Jobben er ferdig",
  "settings.reminders.template_name.review_request": "Be om omtale",
  "settings.reminders.template_name.no_show_followup": "Uteblitt besøk",
  "settings.reminders.template_name.waitlist_slot_open": "Ledig tid fra ventelisten",
  "settings.reminders.when": "Når",
  "settings.reminders.when_before": "Før tiden",
  "settings.reminders.when_after": "Etter hendelsen",
  "settings.reminders.amount": "Hvor langt",
  "settings.reminders.unit.hours": "timer",
  "settings.reminders.unit.days": "dager",
  "settings.reminders.service": "Gjelder tjeneste",
  "settings.reminders.service_all": "Alle tjenester",
  "settings.reminders.active": "Slått på",
  "settings.reminders.add": "Legg til påminnelse",
  "settings.reminders.empty": "Ingen påminnelser ennå. Legg til en, så hører dere fra dere i tide.",
  "settings.reminders.remove_heading": "Fjerne påminnelsen?",
  "settings.reminders.remove_body": "Kommende utsendelser fra denne regelen avlyses. E-poster som alt er sendt blir stående i loggen.",
  "settings.reminders.move_up": "Flytt opp",
  "settings.reminders.move_down": "Flytt ned",
  "settings.reminders.preview": "Forhåndsvisning",
  "settings.reminders.preview_locale": "Språk",
  "settings.reminders.preview_subject": "Emne",
  "settings.reminders.test": "Send test til meg",
  "settings.reminders.test_sent": "Test-e-posten er sendt til deg.",
  "settings.reminders.test_redirected": "Test-e-posten ble sendt til utvikleradressen.",
  "settings.mobile.heading": "Ambulerende virksomhet",
  "settings.mobile.body": "Hvor dere drar ut fra, hvor langt dere kjører og hva reisen koster.",
  "settings.mobile.base": "Utgangspunkt",
  "settings.mobile.base_hint": "Dagen begynner og slutter her. Reisetiden regnes fra denne adressen.",
  "settings.mobile.address": "Adresse",
  "settings.mobile.postcode": "Postnummer",
  "settings.mobile.city": "Sted",
  "settings.mobile.latitude": "Breddegrad",
  "settings.mobile.longitude": "Lengdegrad",
  "settings.mobile.radius": "Hvor langt kjører dere?",
  "settings.mobile.radius_hint": "Kunder utenfor området får ikke bestille dere på nettet.",
  "settings.mobile.km": "km",
  "settings.mobile.speed": "Snitthastighet",
  "settings.mobile.speed_unit": "km/t",
  "settings.mobile.speed_hint": "Brukes til å regne reisetid mellom jobber. 50 km/t passer for de fleste.",
  "settings.mobile.setup": "Tid til lasting og rigg",
  "settings.mobile.surcharge": "Tillegg per kilometer",
  "settings.mobile.postcodes": "Postnummer dere kjører til",
  "settings.mobile.postcodes_hint": "Ett postnummer per rad. La det stå tomt om dere heller vil bruke området over.",
  "settings.mobile.polygon_note": "Et tegnet område finnes fra før og brukes også.",
  "settings.profile.heading": "Profil",
  "settings.profile.body": "Dette ser kundene om dere — i bestillingen og i e-postene.",
  "settings.profile.display_name": "Navn utad",
  "settings.profile.phone": "Telefon",
  "settings.profile.email": "E-post kunder svarer til",
  "settings.profile.email_hint": "Svar på bestillingse-poster havner her.",
  "settings.profile.address": "Gateadresse",
  "settings.profile.address2": "Adresselinje 2",
  "settings.profile.description": "Om verkstedet",
  "settings.profile.description_hint": "To setninger holder. Skriv slik dere snakker.",
  "settings.profile.logo": "Egen logo",
  "settings.profile.logo_hint": "Adressen til et bilde som begynner med https.",
  "settings.profile.review_url": "Lenke for omtaler",
  "settings.profile.photos": "Bilder",
  "settings.profile.photos_hint": "Én bildeadresse per rad, alle med https.",
  "settings.reports.title": "Rapporter",
  "settings.reports.body": "Få tallene dine på e-post automatisk. Rapporten inneholder bare dette verkstedets tall.",
  "settings.reports.add": "Legg til rapport",
  "settings.reports.edit": "Endre rapport",
  "settings.reports.empty": "Ingen rapporter er planlagt ennå.",
  "settings.reports.recipient": "Mottaker",
  "settings.reports.recipient_help": "Bare personer som jobber her kan velges.",
  "settings.reports.period": "Hvor ofte",
  "settings.reports.period.weekly": "Hver uke",
  "settings.reports.period.monthly": "Hver måned",
  "settings.reports.weekday": "Dag",
  "settings.reports.day_of_month": "Dato i måneden",
  "settings.reports.hour": "Tid",
  "settings.reports.metrics": "Tall som skal med",
  "settings.reports.include_csv": "Legg ved regneark (CSV)",
  "settings.reports.active": "Aktiv",
  "settings.reports.sentence.weekly": "Send ukesrapport hver {weekday} {hour} til {recipient}",
  "settings.reports.sentence.monthly": "Send månedsrapport den {day}. hver måned {hour} til {recipient}",
  "settings.reports.paused": "Pauset",
  "settings.reports.send_test": "Send test til meg",
  "settings.reports.test_sent": "Testrapporten er på vei til {email}.",
  "settings.reports.saved": "Rapporten er lagret.",
  "settings.reports.deleted": "Rapporten er fjernet.",
  "settings.reports.delete": "Fjern",
  "settings.reports.last_sent": "Sist sendt for perioden som sluttet {date}",
  "settings.reports.never_sent": "Har ikke blitt sendt ennå",
  "settings.reports.history": "Sendte rapporter",
  "settings.reports.history_empty": "Ingenting er sendt ennå.",
  "settings.reports.status.pending": "I kø",
  "settings.reports.status.sent": "Sendt",
  "settings.reports.status.failed": "Mislyktes",
  "settings.reports.status.skipped": "Hoppet over",
  "settings.reports.status.cancelled": "Avbrutt",
  "settings.reports.no_metrics": "Velg minst ett tall.",
  "settings.reports.duplicate": "Denne personen får allerede en rapport med samme intervall.",
  "weekday.1": "mandag",
  "weekday.2": "tirsdag",
  "weekday.3": "onsdag",
  "weekday.4": "torsdag",
  "weekday.5": "fredag",
  "weekday.6": "lørdag",
  "weekday.7": "søndag",
  "settings.nav.reports": "Rapporter",
  "settings.nav.integrations": "Integrasjoner",
  "settings.messaging.heading": "Meldinger til kunder",
  "settings.messaging.body": "Velg hvordan kundene dine får påminnelser i tillegg til e-post. Kunder som ikke har oppgitt mobilnummer får bare e-post.",
  "settings.messaging.none": "HQ har ikke slått på noen SMS- eller WhatsApp-leverandør ennå.",
  "settings.messaging.one_at_a_time": "Én om gangen. Bytter du leverandør, sendes kommende påminnelser via den nye.",
  "settings.messaging.sender": "Avsendernavn",
  "settings.messaging.sender.hint": "Navnet kunden ser, for eksempel CGTrondheim. 3–11 bokstaver eller tall, uten mellomrom. La stå tomt for ColorGlo HQs standardnavn.",
  "settings.messaging.sender.invalid": "Bruk 3–11 bokstaver eller tall, uten mellomrom, og start med en bokstav.",
  "settings.messaging.active.hint": "Når det er slått av, får kundene bare e-post.",
  "settings.integrations.title": "Integrasjoner",
  "settings.integrations.by": "Av {vendor}",
  "settings.integrations.steps": "{count} trinn",
  "settings.integrations.view": "Vis instruksjoner",
  "settings.integrations.close": "Lukk",
  "settings.integrations.crumb": "Integrasjoner / {name}",
  "settings.integrations.how": "Slik fungerer det",
  "settings.integrations.setup": "Slik kommer du i gang",
  "settings.integrations.configure": "Koble til",
  "settings.integrations.verify.body": "Sjekker nøklene mot leverandøren uten å sende noe.",
  "settings.integrations.channel.email": "E-post",
  "settings.integrations.channel.sms": "SMS",
  "settings.integrations.channel.whatsapp": "WhatsApp",
  "settings.integrations.status.always_on": "Alltid på",
  "settings.integrations.status.not_connected": "Ikke tilkoblet",
  "settings.integrations.status.unverified": "Ikke verifisert",
  "settings.integrations.status.error": "Tilkoblingsfeil",
  "settings.integrations.status.verified": "Verifisert",
  "settings.integrations.status.unavailable": "Ikke slått på av HQ",
  "settings.integrations.status.available": "Tilgjengelig",
  "settings.integrations.status.active": "Aktiv",
  "settings.integrations.how.email": "Bookingbekreftelser og påminnelser sendes alltid på e-post til kunder som har oppgitt e-postadresse. Det gjelder alle verksteder, uansett hva som er valgt for SMS eller WhatsApp.",
  "settings.integrations.how.sms": "Påminnelser sendes som SMS til kunder som har oppgitt mobilnummer. Kunder uten mobilnummer får bare e-post. Hver SMS koster et lite beløp, som ColorGlo HQ betaler.",
  "settings.integrations.how.whatsapp": "Påminnelser sendes som WhatsApp-melding til kunder som har takket ja. Kunder uten WhatsApp får bare e-post.",
  "settings.integrations.email_resend.name": "E-post",
  "settings.integrations.email_resend.description": "E-post til kundene sendes fra ColorGlo HQs konto hos Resend. Alltid på.",
  "settings.integrations.email_resend.hq.step.1": "Domenet send.colorglo.se er verifisert hos Resend.",
  "settings.integrations.email_resend.hq.step.2": "API-nøkkelen settes av utviklerne i servermiljøet, ikke her.",
  "settings.integrations.email_resend.hq.step.3": "Ingenting mer trengs. Alle verksteder sender e-post automatisk.",
  "settings.integrations.email_resend.owner.step.1": "E-post er alltid på for verkstedet ditt.",
  "settings.integrations.email_resend.owner.step.2": "Kundene får bookingbekreftelse og påminnelser på e-post.",
  "settings.integrations.email_resend.owner.step.3": "Du endrer når påminnelsene sendes under Påminnelser.",
  "settings.integrations.sms_elks46.name": "46elks",
  "settings.integrations.sms_elks46.description": "Svensk SMS-leverandør med data i EU. Betales per sendt SMS.",
  "settings.integrations.sms_elks46.hq.step.1": "Opprett en konto på 46elks.se og fyll på saldo.",
  "settings.integrations.sms_elks46.hq.step.2": "Åpne Account i 46elks dashboard og kopier API-brukernavn og API-passord.",
  "settings.integrations.sms_elks46.hq.step.3": "Lim inn nøklene nedenfor og angi et standard avsendernavn, for eksempel ColorGlo.",
  "settings.integrations.sms_elks46.hq.step.4": "Test tilkoblingen, og slå deretter på 46elks for verkstedene.",
  "settings.integrations.sms_elks46.owner.step.1": "Slå på 46elks her. Det erstatter en annen SMS- eller WhatsApp-leverandør hvis du hadde valgt en.",
  "settings.integrations.sms_elks46.owner.step.2": "Angi et eget avsendernavn, for eksempel CGTrondheim, eller la det stå tomt for ColorGlos navn.",
  "settings.integrations.sms_elks46.owner.step.3": "Kunder som oppgir mobilnummer får påminnelser på SMS. Andre får e-post.",
  "settings.integrations.sms_prelude.name": "Prelude SMS",
  "settings.integrations.sms_prelude.description": "SMS via Prelude, som bytter operatør automatisk for høy leveringsgrad.",
  "settings.integrations.sms_prelude.hq.step.1": "Logg inn i Prelude dashboard og opprett en API-nøkkel under API Keys.",
  "settings.integrations.sms_prelude.hq.step.2": "Be Prelude lage en testmal uten variabler, og malene for bookingbekreftelse og påminnelse på svensk, norsk og engelsk.",
  "settings.integrations.sms_prelude.hq.step.3": "Lim inn API-nøkkelen og testmalens ID nedenfor. Avsendernavnet må være godkjent i Prelude.",
  "settings.integrations.sms_prelude.hq.step.4": "Test tilkoblingen, send en test til deg selv, og slå deretter på Prelude for verkstedene. Testmeldingen er den virkelige kontrollen: tilkoblingstesten kan godta en nøkkel som likevel ikke får sende.",
  "settings.integrations.sms_prelude.owner.step.1": "Slå på Prelude SMS her. Det erstatter en annen SMS- eller WhatsApp-leverandør hvis du hadde valgt en.",
  "settings.integrations.sms_prelude.owner.step.2": "Angi et eget avsendernavn eller la det stå tomt for ColorGlos navn. HQ må ha fått navnet godkjent hos Prelude.",
  "settings.integrations.sms_prelude.owner.step.3": "Kunder som oppgir mobilnummer får påminnelser på SMS. Andre får e-post.",
  "settings.integrations.whatsapp_meta.name": "WhatsApp",
  "settings.integrations.whatsapp_meta.description": "WhatsApp direkte fra Meta. Kunden må ha WhatsApp og ha takket ja til meldinger.",
  "settings.integrations.whatsapp_meta.hq.step.1": "Verifiser ColorGlo som bedrift i Meta Business Manager og legg til et telefonnummer under WhatsApp.",
  "settings.integrations.whatsapp_meta.hq.step.2": "Opprett en systembruker med tillatelsen whatsapp_business_messaging og generer et permanent token.",
  "settings.integrations.whatsapp_meta.hq.step.3": "Lim inn token og telefonnummer-ID nedenfor. hello_world brukes som testmelding.",
  "settings.integrations.whatsapp_meta.hq.step.4": "Test tilkoblingen, send en test til deg selv, og slå deretter på WhatsApp for verkstedene.",
  "settings.integrations.whatsapp_meta.owner.step.1": "Slå på WhatsApp her. Det erstatter SMS hvis du hadde valgt det.",
  "settings.integrations.whatsapp_meta.owner.step.2": "Meldinger sendes fra ColorGlos godkjente WhatsApp-nummer. Du trenger ikke angi avsendernavn.",
  "settings.integrations.whatsapp_meta.owner.step.3": "Kunder som takker ja får påminnelser i WhatsApp. Andre får e-post.",
  "settings.integrations.whatsapp_prelude.name": "Prelude WhatsApp",
  "settings.integrations.whatsapp_prelude.description": "WhatsApp via Prelude, med samme konto og maler som Prelude SMS.",
  "settings.integrations.whatsapp_prelude.hq.step.1": "Logg inn i Prelude dashboard og opprett en API-nøkkel, eller bruk den samme som for Prelude SMS.",
  "settings.integrations.whatsapp_prelude.hq.step.2": "Be Prelude koble til et WhatsApp-nummer og sette opp malene som kun WhatsApp, slik at de aldri faller tilbake til SMS.",
  "settings.integrations.whatsapp_prelude.hq.step.3": "Lim inn API-nøkkelen og testmalens ID nedenfor.",
  "settings.integrations.whatsapp_prelude.hq.step.4": "Test tilkoblingen, send en test til deg selv, og slå deretter på Prelude WhatsApp for verkstedene. Testmeldingen er den virkelige kontrollen: tilkoblingstesten kan godta en nøkkel som likevel ikke får sende.",
  "settings.integrations.whatsapp_prelude.owner.step.1": "Slå på Prelude WhatsApp her. Det erstatter SMS hvis du hadde valgt det.",
  "settings.integrations.whatsapp_prelude.owner.step.2": "Meldinger sendes fra ColorGlos WhatsApp-nummer hos Prelude. Du trenger ikke angi avsendernavn.",
  "settings.integrations.whatsapp_prelude.owner.step.3": "Kunder som takker ja får påminnelser i WhatsApp. Andre får e-post.",
  "settings.messaging.active_via": "Send påminnelser via {provider}",
  "settings.messaging.sender.after_choosing": "Slå på {provider} for å velge avsendernavn.",
  "settings.messaging.sender.whatsapp": "WhatsApp-meldinger sendes fra ColorGlos godkjente nummer, så det finnes ikke noe avsendernavn å velge.",
  "settings.integrations.sms_twilio.name": "Twilio",
  "settings.integrations.sms_twilio.description": "SMS via Twilio, en global leverandør. Betales per sendt SMS.",
  "settings.integrations.sms_twilio.hq.step.1": "Opprett eller logg inn på en konto på twilio.com og oppgrader den fra prøvemodus.",
  "settings.integrations.sms_twilio.hq.step.2": "Kopier Account SID og Auth Token fra startsiden i Twilio Console.",
  "settings.integrations.sms_twilio.hq.step.3": "Lim dem inn nedenfor og angi en standardavsender: et navn som ColorGlo eller et Twilio-nummer.",
  "settings.integrations.sms_twilio.hq.step.4": "Test tilkoblingen, send en test til deg selv, og slå deretter på Twilio for verkstedene.",
  "settings.integrations.sms_twilio.owner.step.1": "Slå på Twilio her. Det erstatter en annen SMS- eller WhatsApp-leverandør hvis du hadde valgt en.",
  "settings.integrations.sms_twilio.owner.step.2": "Angi et eget avsendernavn, for eksempel CGTrondheim, eller la det stå tomt for ColorGlos navn.",
  "settings.integrations.sms_twilio.owner.step.3": "Kunder som oppgir mobilnummer får påminnelser på SMS. Andre får e-post.",
  "settings.rules.inspection": "Befaringstid",
  "settings.rules.inspection_hint": "Hvor lang tid hver bestilling får. Pris og tid for selve jobben avtales med kunden etter befaringen.",
  "settings.staff.open": "Åpne",
  "settings.staff.back": "Personale og ressurser",
  "settings.staff.tab.overview": "Oversikt",
  "settings.staff.tab.profile": "Profil",
  "settings.staff.tab.schedule": "Timeplan",
  "settings.staff.tab.time_off": "Fravær",
  "settings.staff.tab.activity": "Aktivitet",
  "settings.staff.role.franchise_owner": "Eier",
  "settings.staff.role.franchise_staff": "Ansatt",
  "settings.staff.status.active": "Aktiv",
  "settings.staff.status.inactive": "Deaktivert",
  "settings.staff.no_account": "{name} har ingen innlogging. Inviter personen på e-post for å gi tilgang.",
  "settings.staff.account.heading": "Innlogging",
  "settings.staff.account.body": "Navnet og e-postadressen personen logger inn med.",
  "settings.staff.account.name": "Navn",
  "settings.staff.account.email": "E-postadresse",
  "settings.staff.account.email_hint": "Vi varsler både den gamle og den nye adressen.",
  "settings.staff.account.phone": "Telefon",
  "settings.staff.account.language": "Språk",
  "settings.staff.account.saved": "Lagret.",
  "settings.staff.account.owner_locked": "Eierkontoer endres av HQ.",
  "settings.staff.account.shared": "{name} jobber også på et annet verksted. E-postadressen og utlogging håndteres av HQ.",
  "settings.staff.security.heading": "Sikkerhet",
  "settings.staff.security.last_active": "Sist aktiv {when}",
  "settings.staff.security.never": "Har ikke logget inn ennå",
  "settings.staff.security.sessions.one": "Innlogget på {count} enhet",
  "settings.staff.security.sessions.other": "Innlogget på {count} enheter",
  "settings.staff.security.reset": "Send lenke for nytt passord",
  "settings.staff.security.reset_title": "Send lenke til {email}?",
  "settings.staff.security.reset_body": "Lenken gjelder i 24 timer. Det gamle passordet virker til et nytt er valgt.",
  "settings.staff.security.reset_send": "Send lenken",
  "settings.staff.security.reset_sent": "Lenken er sendt til {email}.",
  "settings.staff.security.sign_out": "Logg ut av alle enheter",
  "settings.staff.security.sign_out_title": "Logge ut {name} overalt?",
  "settings.staff.security.sign_out_body": "{name} logges ut på alle enheter og må logge inn igjen.",
  "settings.staff.security.sign_out_confirm": "Logg ut",
  "settings.staff.security.signed_out": "{name} er logget ut.",
  "settings.staff.schedule.heading": "Kalender og arbeidstid",
  "settings.staff.schedule.body": "Hvordan {name} vises i kalenderen, når de jobber og hvilke tjenester de utfører.",
  "settings.staff.schedule.calendar_name": "Navn i kalenderen",
  "settings.staff.danger.heading": "Deaktiver",
  "settings.staff.danger.body": "{name} forsvinner fra kalenderen og logges ut. Innloggingen stenges, Google-kalenderen kobles fra og kalenderfeeder slutter å virke. Historikken beholdes.",
  "settings.staff.danger.deactivate": "Deaktiver {name}",
  "settings.staff.danger.reactivate_body": "{name} er deaktivert. Aktiver igjen for å gi tilbake kalenderkolonnen og innloggingen.",
  "settings.staff.invite_resend": "Send igjen",
  "settings.staff.invite_resent": "Invitasjonen er sendt igjen.",
  "settings.staff.time_off.heading": "Fravær",
  "settings.staff.time_off.body": "Ferie, sykdom og opplæring. Tiden kan ikke bookes.",
  "settings.staff.time_off.add": "Legg til fravær",
  "settings.staff.time_off.from": "Fra",
  "settings.staff.time_off.to": "Til og med",
  "settings.staff.time_off.start": "Starttid",
  "settings.staff.time_off.end": "Sluttid",
  "settings.staff.time_off.reason": "Notat",
  "settings.staff.time_off.added": "Fraværet er lagret.",
  "settings.staff.time_off.removed": "Fraværet er fjernet.",
  "settings.staff.time_off.upcoming": "Kommende",
  "settings.staff.time_off.past": "Siste år",
  "settings.staff.time_off.empty": "Ikke noe fravær registrert.",
  "settings.staff.time_off.days.one": "{count} dag",
  "settings.staff.time_off.days.other": "{count} dager",
  "settings.staff.time_off.training_hint": "Opplæring trenger start- og sluttid.",
  "settings.staff.time_off.invalid_range": "Sluttdatoen må være samme dag eller senere, og høyst 120 dager frem.",
  "settings.staff.activity.heading": "Aktivitet",
  "settings.staff.activity.body": "Hva som er endret for {name}, og av hvem.",
  "settings.staff.activity.empty": "Ingenting er endret ennå.",
  "settings.staff.activity.via_hq": "via HQ",
  "settings.staff.activity.system": "Systemet",
  "settings.staff.activity.resource_created": "Lagt til",
  "settings.staff.activity.resource_updated": "Kalender eller timeplan endret",
  "settings.staff.activity.resource_deactivated": "Deaktivert",
  "settings.staff.activity.staff_account_updated": "Innloggingsdetaljer endret",
  "settings.staff.activity.password_reset_sent": "Fikk en lenke for nytt passord",
  "settings.staff.activity.password_reset_completed": "Valgte et nytt passord",
  "settings.staff.activity.staff_signed_out": "Logget ut av alle enheter",
  "settings.staff.activity.blocker_created": "Fravær lagt til: {kind}, {date}",
  "settings.staff.activity.blocker_deleted": "Fravær fjernet: {kind}, {date}",
  "settings.staff.activity.other": "Endring",
  "settings.staff.overview.heading": "Oversikt",
  "settings.staff.overview.body": "Hvordan det går for {name}. Bare du som eier ser tallene.",
  "settings.staff.overview.period": "Periode",
  "settings.staff.overview.period.30": "Siste 30 dager",
  "settings.staff.overview.period.90": "Siste 90 dager",
  "settings.staff.overview.period.365": "Siste 12 måneder",
  "settings.staff.overview.previous": "{value} perioden før",
  "settings.staff.overview.kpi.jobs_completed": "Utførte jobber",
  "settings.staff.overview.kpi.worked": "Arbeidede timer",
  "settings.staff.overview.kpi.revenue": "Omsetning",
  "settings.staff.overview.kpi.job_value": "Snittverdi per jobb",
  "settings.staff.overview.kpi.utilisation": "Belegg",
  "settings.staff.overview.kpi.no_show_rate": "Uteblitte",
  "settings.staff.overview.kpi.cancellation_rate": "Avbestilte",
  "settings.staff.overview.hours": "{hours} t",
  "settings.staff.overview.hint.utilisation": "Booket tid delt på arbeidstid, samme beregning som for verkstedet.",
  "settings.staff.overview.time_off": "Fravær i perioden",
  "settings.staff.overview.days": "{days} dager",
  "settings.staff.overview.chart.jobs": "Utførte jobber",
  "settings.staff.overview.chart.utilisation": "Belegg",
  "settings.staff.overview.chart.table": "Vis som tabell",
  "settings.staff.overview.chart.period": "Periode",
  "settings.staff.overview.services": "Jobber per tjeneste",
  "settings.staff.overview.services.jobs": "Jobber",
  "settings.staff.overview.services.service": "Tjeneste",
  "settings.staff.overview.recent": "Siste jobber",
  "settings.staff.overview.empty": "Ingen jobber i perioden."
}
